import React from 'react'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { CircularProgress } from '@mui/material'
import FormInput from '@/components/Common/FormInput'
import { FormValues } from '@/services/types/APIRequestType'
import { formatPhoneNumber } from '@/utils'
import close_icon from '@/assets/close_icon.svg'

interface FormErrors {
  firstName?: string
  lastName?: string
}
interface SubAdminModalContentProps {
  open: boolean
  handleClose: () => void
  isEdit: boolean
  formValues: FormValues
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleSubmit: () => void
  isPending: boolean
  renderErrorMsg: () => JSX.Element | null
  selectedId: string | null
  isEnabled: boolean | undefined
  resetAdmin: boolean
  handleCredentials: (id: string | null) => void
  errors: FormErrors
}

const SubAdminModalContent: React.FC<SubAdminModalContentProps> = ({
  open,
  handleClose,
  isEdit,
  formValues,
  handleChange,
  handleSubmit,
  isPending,
  renderErrorMsg,
  selectedId,
  isEnabled,
  resetAdmin,
  handleCredentials,
  errors,
}) => {
  const isFormValid = () => {
    return (
      formValues.firstName &&
      formValues.lastName &&
      formValues.phone &&
      formValues?.email
    )
  }

  return (
    <Fade in={open}>
      <Box className="sub-admin-modal-style">
        <div className="model-close" onClick={handleClose}>
          <img src={close_icon} alt="Close" />
        </div>
        <Typography id="transition-modal-title" variant="h6" component="h2">
          <div className="create-subadmin pb-5">
            {isEdit ? 'Details' : 'Create Sub-Admin'}
          </div>
        </Typography>
        <div className="flex flex-col gap-10">
          <div className="input-block-wrapper">
            <FormInput
              type="text"
              label="First Name"
              name="firstName"
              value={formValues.firstName}
              onChange={handleChange}
              error={!!errors.firstName}
              helperText={errors.firstName}
              readOnly={isEdit}
            />
            <FormInput
              type="text"
              label="Last Name"
              name="lastName"
              value={formValues.lastName}
              onChange={handleChange}
              error={!!errors.lastName}
              helperText={errors.lastName}
              readOnly={isEdit}
            />
          </div>
          <div className="input-block-wrapper">
            <FormInput
              type="string"
              label="Phone Number"
              name="phone"
              value={formatPhoneNumber(formValues.phone!, '+1')}
              onChange={handleChange}
              readOnly={isEdit}
            />

            <FormInput
              type="email"
              label="Email Address"
              name="email"
              value={formValues?.email}
              onChange={handleChange}
              readOnly={isEdit}
            />
          </div>
        </div>
        {renderErrorMsg()}
        <div className="btn-subadmin-create">
          <Button
            className={`model-btn2 ${isEdit && 'disable'}`}
            disabled={isEdit || !isFormValid() || isPending}
            onClick={handleSubmit}
          >
            {isPending ? (
              <CircularProgress className="!text-[#fb5012] !text-2xl" />
            ) : isEdit ? (
              'Save User'
            ) : (
              'Generate User'
            )}
          </Button>
          {isEdit && (
            <Button
              className="model-btn1"
              onClick={() => handleCredentials(selectedId)}
              disabled={resetAdmin}
            >
              {resetAdmin ? (
                <CircularProgress className="!text-[#181a21] !text-2xl" />
              ) : isEnabled ? (
                'Enable'
              ) : (
                'Disable'
              )}
            </Button>
          )}
        </div>
      </Box>
    </Fade>
  )
}

export default SubAdminModalContent
